import http from "./httpService";

class MakercartActivityService {
  async getMakercartActivities(params) {
    const newParams = {
      sort_dir: "asc",
      sort_field: "Makercart Activity",
      ...params,
    };
    const url = http.getUrlWithParams("/airtable", newParams);
    return http.get(url);
  }

  async getPrivateEducatorGuides(params) {
    const url = http.getUrlWithParams("/educator-guide/user", params);
    return http.get(url);
  }

  async getLimitCounter() {
    return http.get("/makercart-analytics/public-access-count");
  }

  async recordPrompt() {
    return http.get("/makercart-analytics/record-prompt");
  }

  async getAnalytics(params) {
    const url = http.getUrlWithParams("/admin/makercart-analytics", params);
    return http.get(url);
  }

  async getEducatorGuides(params) {
    const url = http.getUrlWithParams("/admin/educator-guide", params);
    return http.get(url);
  }

  async getEducatorGuideById(id) {
    return http.get(`/admin/educator-guide/${id}`);
  }

  async createEducatorGuide(data) {
    return http.post("/admin/educator-guide", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async assignSlides(data) {
    return http.put("/admin/educator-guide-slides/assign", data);
  }

  async requestThumbnailSlides(data) {
    return http.post("/admin/educator-guide-slides/upload", data);
  }

  async updateEducatorGuide(id, data) {
    const config =
      data instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

    return http.put(`/admin/educator-guide/${id}`, data, config);
  }

  async deleteEducatorGuide(id) {
    return http.delete(`/admin/educator-guide/${id}`);
  }

  async duplicateEducatorGuide(id) {
    return http.post(`/admin/educator-guide/duplicate/${id}`);
  }

  async createBulkMaterials(data) {
    return http.post("/admin/educator-guide-instructionals/bulk", data);
  }

  async createMaterial(data) {
    return http.post("/admin/educator-guide-instructionals", data);
  }

  async updateMaterials(id, data) {
    return http.put(`/admin/educator-guide-instructionals/${id}`, data);
  }

  async deleteMaterials(id) {
    return http.delete(`/admin/educator-guide-instructionals/${id}`);
  }
}

export default new MakercartActivityService();
